import _import from './_import.js';

export default [
    // g3
    // {
    //     path: 'cloudsim/g3',
    //     component: _import('cloudsim/g3')
    // },
    // // u2
    // {
    //     path: 'cloudsim/u2',
    //     component: _import('cloudsim/u2')
    // },
    // // why_glocalme_wifi
    // {
    //     path: 'cloudsim/why_glocalme_wifi',
    //     component: _import('cloudsim/why_glocalme_wifi')
    // },
	// // roaming_free_wifi_g4pro
    // {
    //     path: 'cloudsim/roaming_free_wifi_g4pro',
    //     component: _import('cloudsim/roaming_free_wifi_g4pro')
    // },

    // cloudsim 动态路由
    {
        path: 'cloudsim/:type',
        component: _import('cloudsim/common_wifi')
    }
];


// WEBPACK FOOTER //
// ./src/router/cloudsim.js